import React from 'react';
import{ useForm } from 'react-hook-form';
import { Link as RouterLink } from 'react-router-dom';
import { useApolloClient } from '@apollo/client';
import { useMutation } from '@apollo/client';
import { PRE_REGISTRATION, PRE_REGISTRATION_FACULTY} from '../../graphql/mutations';
import ErrorMessage from '../../components/ErrorMessage';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { getErrorMsg } from '../../utils/helperFuncs';
import { useState } from 'react';
import RegisterVector from '../../assets/svg/register.svg'
import { useHistory } from "react-router-dom";

import {
  TextField,
  Button,
  Typography,
  InputAdornment,
  Link,
  Grid,
} from '@material-ui/core';

import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import { useAuthFormStyles } from '../../styles/muiStyles';
import PersonIcon from '@material-ui/icons/Person';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import EmailIcon from '@material-ui/icons/Email';

const validationSchema = yup.object({
  email: yup
    .string()
    .required('Required')
    .email(),
  firstName: yup
    .string()
    .required('Required'),
  lastName: yup
    .string()
    .required('Required'),
});

const RegisterForm = () => {
  let history = useHistory();
  const [errorMsg, setErrorMsg] = useState(null);
  const [role, setValue] = React.useState('student');
  const classes = useAuthFormStyles();

  const handleChange = (event) => {
    setValue(event.target.value);
  };

  const { register, handleSubmit, reset, errors } = useForm({
    mode: 'onChange',
    resolver: yupResolver(validationSchema),
  });
  const client = useApolloClient();
  const [preRegistration, { loading }] = useMutation(PRE_REGISTRATION, {
    onError: (err) => {
      setErrorMsg(getErrorMsg(err));
    },
  });

  const [preRegistrationFaculty] = useMutation(PRE_REGISTRATION_FACULTY, {
    onError: (err) => {
      setErrorMsg(getErrorMsg(err));
    },
  });

const onRegister = ({ email, firstName, lastName }) => {
  if (role === 'student'){
    preRegistration({
      variables: { email, firstName, lastName, role },
      update: (_,) => {
        history.push("/email-confirmation-notice");
        reset();
      },
    });
    client.clearStore();
    }
    else{
    preRegistrationFaculty({
      variables: { email, firstName, lastName, role },
      update: (_,) => {
        history.push("/email-confirmation-notice");
        reset();
      },
    });
    client.clearStore();
  }
  };

  return (
    <div className={classes.row}>
      <div className ={classes.column}>
      <img 
            src={RegisterVector} 
            alt="Home Vector" 
            className={classes.homeVector}
          />
      </div>
      <div className ={classes.column}>
        <div className={classes.root}>
          <Typography variant="h4" styles={{color:'#fff'}} >
            Register to <strong className={classes.register}>NEUMeet!</strong>
          </Typography>
          
          <form onSubmit={handleSubmit(onRegister)} className={classes.form}>
          <Grid container spacing={2}> 
            <Grid item xs={12} sm={6}>
            <TextField
                required
                fullWidth
                autoFocus={true}
                inputRef={register}
                name="firstName"
                type="text"
                label="First Name"
                variant="outlined"
                error={'firstName' in errors}
                helperText={'firstName' in errors ? errors.firstName.message : ''}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <PersonIcon color="primary" />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                      required
                      fullWidth                   
                      inputRef={register}
                      name="lastName"
                      type="text"
                      label="Last Name"
                      variant="outlined"
                      error={'lastName' in errors}
                      helperText={'lastName' in errors ? errors.lastName.message : ''}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <PersonIcon color="primary" />
                          </InputAdornment>
                        ),
                      }}
                /> 
            </Grid>
              <Grid item xs={12}>
              <TextField
                  required
                  fullWidth
                  inputRef={register}
                  name="email"
                  type="text"
                  label="Email"
                  variant="outlined"
                  error={'email' in errors}
                  helperText={'email' in errors ? errors.email.message : ''}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <EmailIcon color="primary" />
                      </InputAdornment>
                    ),
                  }}
              />
            </Grid>
            <Grid item xs={12}>
            <FormControl component="fieldset">
            <RadioGroup
              aria-label="gender"
              name="controlled-radio-buttons-group"
              value={role}
              onChange={handleChange}
            >
            <div>
              <FormControlLabel value="student" control={<Radio />} label="Student" />
              <FormControlLabel value="faculty" control={<Radio />} label="Faculty" />
            </div>
              
            </RadioGroup>
          </FormControl>
            </Grid>
            <Grid item xs={12}>
              <Button
                color="primary"
                variant="contained"
                size="large"
                fullWidth
                startIcon={<PersonAddIcon />}
                type="submit"
                disabled={loading}
                className={classes.submitButton}
              >
                Sign Up
              </Button>
            </Grid>
          </Grid>
          </form>
          <Typography variant="body1" className={classes.footerText}>
            Already have an account?{' '}
            <Link className={classes.link} component={RouterLink} to="/login">
              Log In
            </Link>
          </Typography>
          <ErrorMessage
            errorMsg={errorMsg}
            clearErrorMsg={() => setErrorMsg(null)}
          />
        </div>
      </div>
      
    </div>
  );
};

export default RegisterForm;
